var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.077L17.077 6l.923.923L12.923 12 18 17.077l-.923.923L12 12.923 6.923 18 6 17.077 11.077 12 6 6.923 6.923 6 12 11.077z",
    id: "CloseIcon_svg__a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    xlinkHref: "#CloseIcon_svg__a",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml,%3csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3c!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com --%3e %3ctitle%3ex%3c/title%3e %3cdesc%3eCreated with Sketch.%3c/desc%3e %3cdefs%3e %3cpath d='M12,11.0769231 L17.0769231,6 L18,6.92307692 L12.9230769,12 L18,17.0769231 L17.0769231,18 L12,12.9230769 L6.92307692,18 L6,17.0769231 L11.0769231,12 L6,6.92307692 L6.92307692,6 L12,11.0769231 Z' id='path-1'%3e%3c/path%3e %3c/defs%3e %3cg id='x' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='Icons-/-Close-/-L'%3e %3cmask id='mask-2' fill='white'%3e %3cuse xlink:href='%23path-1'%3e%3c/use%3e %3c/mask%3e %3cuse id='Mask' fill='%23000000' fill-rule='evenodd' xlink:href='%23path-1'%3e%3c/use%3e %3c/g%3e %3c/g%3e %3c/svg%3e";
export { SvgCloseIcon as ReactComponent };